import { classNames } from "../../../helpers/classNames";

const SelectOption = ({ value, className, ...props }) => {
  return (
    <button
      type="button"
      onClick={() => {
        if (!props?.disabled) {
          props?.onChange(value);
          if (!props?.multiple) {
            props?.toggleOpen();
          }
        }
      }}
      className={classNames("flex flex-col w-full overflow-hidden", className)}>
      {props?.children}
    </button>
  );
};

export default SelectOption;
